module.exports = __webpack_public_path__ + "img/FGr_Brückenbau_B.ac31ad06.svg";